import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  HostListener,
} from '@angular/core';
import { SubmitButtonShared } from 'src/app/presentation/general/shared/submit-button-shared';
import { Subscription } from 'rxjs';
import { RegisterShared } from 'src/app/presentation/general/shared/register-shared';
import { AuthenticationAnalyticsService } from 'src/app/data/repository/analytics-repository/authentication-analytics.service';

@Component({
  selector: 'app-credential',
  templateUrl: './credential.component.html',
  styleUrls: ['./credential.component.scss'],
})
export class CredentialComponent implements OnInit, OnDestroy {
  @Input() pageNumber: number;
  @Input() currentPageNumber: number;
  name: string;
  subscription: Subscription;
  isFocuse = false;

  constructor(
    private submitButtonShared: SubmitButtonShared,
    private registerShared: RegisterShared,
    private authAnalytics: AuthenticationAnalyticsService
  ) {
    this.subscription = this.submitButtonShared.nextButtonClickObs$.subscribe(
      (clicked) => {
        if (clicked && this.pageNumber === this.currentPageNumber) {
          this.registerShared.name = this.name;
          this.registerShared.nextPage();
          // console.log('name', this.registerShared.name)
        }
      }
    );
  }

  ngOnInit() {
    this.authAnalytics.analyticAuthenticationRegisterStarted();
    this.submitButtonShared.activateNextButton(false);
    this.registerShared.registerDeactivateButton(0);
  }

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  onFocus() {
    this.isFocuse = true;
  }
  onBlur() {
    this.isFocuse = false;
  }
  clearInput() {
    this.name = '';
    this.activateButton('');
  }
  activateButton(data: string) {
    if (data.trim() == '') {
      this.submitButtonShared.activateNextButton(false);
      this.registerShared.registerDeactivateButton(0);
    } else {
      this.submitButtonShared.activateNextButton(true);
      this.registerShared.registerActivateButton(0);
    }
  }
}
